// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
let TipBoxes = require("../../../reason/clients/components/TipBoxes.bs.js");
let Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Checkbox = require("../../../uikit/reason/atoms/Form/Form__Checkbox.bs.js");
let GeocodingError = require("../propertyForms/Geocoding/GeocodingError.bs.js");
let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let CityZipAutocompleteV5 = require("../propertyForms/CityZipAutocompleteV5.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let PropertyWizardFormRelay__Elements = require("./PropertyWizardFormRelay__Elements.bs.js");
let PropertyMlsValidationStatusComponents = require("../propertyForms/Geocoding/PropertyMlsValidationStatusComponents.bs.js");
let PropertyAddressValidationDuplicatePropertyError = require("../propertyForms/Geocoding/PropertyAddressValidationDuplicatePropertyError.bs.js");
let PropertyWizardFormRelay__Validators__KeyFacts__Address = require("./PropertyWizardFormRelay__Validators__KeyFacts__Address.bs.js");
let PropertyWizardRelayKeyFactsStreetAddress_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.bs.js");
let PropertyWizardRelayKeyFactsStreetAddress_formState_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__KeyFacts__StreetAddress(props) {
  let duplicatedProperty = props.duplicatedProperty;
  let stepHasBeenTouched = props.stepHasBeenTouched;
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_draft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsStreetAddress_formState_graphql.node, convertFragment$1, props.formState);
  let match = PropertyWizardFormRelay.Context.use();
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let streetAddressValid = PropertyWizardFormRelay__Validators__KeyFacts__Address.StreetAddress.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let tmp;
  if (streetAddressValid !== undefined) {
    if (streetAddressValid.NAME === "Invalid") {
      let match$1 = streetAddressValid.VAL;
      tmp = match$1 === "missingAddress" ? ({
          NAME: "Error",
          VAL: "is required"
        }) : (
          match$1 === "propertyAlreadyOnMls" ? ({
              NAME: "Error",
              VAL: ""
            }) : (
              match$1 === "mlsStatusCheckFailed" ? ({
                  NAME: "Error",
                  VAL: "We had a problem validating your address."
                }) : (
                  match$1 === "outsideChapterBoundaries" ? ({
                      NAME: "Error",
                      VAL: "This property is outside of the chapter boundaries."
                    }) : (
                      match$1 === "missingCity" ? undefined : ({
                          NAME: "Error",
                          VAL: ""
                        })
                    )
                )
            )
        );
    } else {
      tmp = "Valid";
    }
  } else {
    tmp = undefined;
  }
  let addressProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.address = value;
      return newrecord;
    }
  }, stepHasBeenTouched, draft.draftProperty.address, tmp);
  let areaOption = Stdlib_Option.map(draft.draftProperty.selectedArea, area => ({
    id: area.id,
    label: area.label
  }));
  let areaProps = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (current, value) => {
      let newrecord = {...current};
      newrecord.selectedArea = value !== undefined ? ({
          id: value.id,
          label: value.label
        }) : undefined;
      return newrecord;
    }
  }, stepHasBeenTouched, areaOption, PropertyWizardFormRelay__Validators__KeyFacts__Address.CityOrZip.useIsValid(draft.fragmentRefs, formState.fragmentRefs));
  let loading;
  loading = formState.geocodingStatus === "Called" ? true : formState.mlsStatus === "Called";
  let hideAddress = Stdlib_Option.getOr(draft.draftProperty.hideAddress, false);
  let tmp$1;
  if (typeof streetAddressValid === "object" && streetAddressValid.NAME === "Invalid") {
    let match$2 = streetAddressValid.VAL;
    tmp$1 = match$2 === "geocodingFailed" ? JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(GeocodingError.make, {
          reason: "UnableToGeocode"
        }),
        className: "mt-4"
      }) : (
        match$2 === "propertyAlreadyOnMls" ? (
            match.mode === "New" ? JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(PropertyMlsValidationStatusComponents.AlreadyOnMlsCannotBeBroadcast.make, {}),
                className: "mt-4"
              }) : null
          ) : (
            match$2 === "duplicateListing" ? (
                duplicatedProperty !== undefined ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(PropertyAddressValidationDuplicatePropertyError.make, {
                      property: Primitive_option.valFromOption(duplicatedProperty)
                    }),
                    className: "mt-4"
                  }) : null
              ) : (
                match$2 === "outsideChapterBoundaries" ? JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(GeocodingError.make, {
                      reason: "OutsideChapterBoundaries"
                    }),
                    className: "mt-4"
                  }) : null
              )
          )
      );
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs(FormV5.FormSection.make, {
    tipbox: addressProps.focused ? TipBoxes.PropertyWizard.streetAddress : undefined,
    children: [
      JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Grid.make, {
        children: [
          JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
            width: 12,
            widthMd: 6,
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Form__Input.make, {
                    labelText: "Street Address",
                    onChange: event => addressProps.onChange(event.currentTarget.value),
                    onBlur: param => {
                      updateDraftProperty(current => {
                        let newrecord = {...current};
                        newrecord.addressToGeocode = addressProps.value;
                        return newrecord;
                      });
                      addressProps.onBlur();
                    },
                    onFocus: param => addressProps.onFocus(),
                    status: addressProps.status,
                    value: addressProps.valueAsString
                  }),
                  loading ? JsxRuntime.jsx(PropertyWizardFormRelay__Elements.LoadingSpinner.make, {}) : null
                ],
                className: "relative grow"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(Form__Components.FieldError.make, {
                  valid: addressProps.valid
                })
              })
            ]
          }),
          JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
            width: 12,
            widthMd: 6,
            children: [
              JsxRuntime.jsx(Form__Label.make, {
                labelText: "City or Zip"
              }),
              JsxRuntime.jsx(CityZipAutocompleteV5.make, {
                value: Primitive_option.some(areaProps.value),
                onChange: value => areaProps.onChange(value),
                onBlur: param => areaProps.onBlur(),
                status: areaProps.status
              }),
              JsxRuntime.jsx(Form__Components.FieldError.make, {
                valid: areaProps.valid
              })
            ]
          }),
          JsxRuntime.jsx(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
            width: 12,
            widthMd: 6,
            children: JsxRuntime.jsx(Form__Checkbox.make, {
              onChange: _e => updateDraftProperty(c => {
                let newrecord = {...c};
                newrecord.hideAddress = !hideAddress;
                return newrecord;
              }),
              name: "hideAddress",
              checked: hideAddress,
              label: "Hide address from others"
            })
          })
        ]
      }),
      tmp$1
    ]
  });
}

let Components;

let FormSection;

let TextInputField;

let Grid;

let Cell;

let Checkbox;

let TipBoxes$1;

let Validators;

let FormElements;

let FormUtils;

let make = PropertyWizardRelay__KeyFacts__StreetAddress;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Grid = Grid;
exports.Cell = Cell;
exports.Checkbox = Checkbox;
exports.TipBoxes = TipBoxes$1;
exports.Validators = Validators;
exports.FormElements = FormElements;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* FormV5 Not a pure module */
